import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-machinemenu",
  "use": "icon-soc-m-machinemenu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-machinemenu\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"192\" y=\"192\" width=\"640\" height=\"640\" rx=\"40\" />\r\n<path d=\"M320 320h160v48H320zM320 448h384v48H320zM320 576h288v48H320z\" fill=\"#fff\" />\r\n<circle cx=\"720\" cy=\"320\" r=\"36\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-machinemenu.svg
// module id = aL7t
// module chunks = 492